import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'auth-layout',
  templateUrl: './auth-layout.component.html',
  styleUrls: ['./auth-layout.component.scss']
})
export class AuthLayoutComponent implements OnInit {
  @Output() getRefferalCode = new EventEmitter(false)
  @Input() title : string
  @Input() subTitile : string
  @Input() type : string
  @Input() sideImage : string
  @Input() isHiddenImage : boolean

  referalCode : string

  constructor(private router: Router,private activatedRoute : ActivatedRoute) { }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((res)=>{
      if(res.refferalCode){
        localStorage.setItem("refferalCode",res.refferalCode )
        this.referalCode = res.refferalCode
       
      }
      this.generateReferal()
    })
    if(!this.referalCode && localStorage.getItem("refferalCode")){
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: { referalCode: localStorage.getItem("refferalCode") },
        queryParamsHandling: 'merge', // <- This keeps existing query params and adds/updates the new one
      });
    }
  }

  generateReferal(){
    if(this.referalCode){
      this.getRefferalCode.emit(this.referalCode)
    }
    else{
      this.getRefferalCode.emit(this.referalCode)
    }
  }
}
